import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import HoverIconButton from "components/HoverIconButton";
import { STATE_KEYS } from "utils/constants/state";
import ConfirmIconButton from "components/ConfirmIconButton";
import { removeEntity } from "utils/builder";
import { getBlockRemovalSlides } from "utils/constants/confirm";
import { SMALL_ICON_SIZE } from "utils/constants/ui";

const PanelHeader = ({ uuid, uid, title, resetValues }) => {
  const {
    values,
    setFieldValue,
    setValues,
    setFieldTouched
  } = useFormikContext();

  const buttonProps = {
    size: SMALL_ICON_SIZE,
    onClick: () => {
      setFieldValue(STATE_KEYS.EDITOR.ACTIVE_BLOCK, null);
      setFieldValue(STATE_KEYS.EDITOR.VISIBILITY_PANEL, false);
    },
    type: "close"
  };

  const titleProps = {
    className: "f5 ttu tracked f6 fw6 pointer link__decoration--hover"
  };
  if (resetValues) {
    titleProps.onClick = () =>
      setFieldValue(resetValues.key, resetValues.value);
  }

  return (
    <Fragment>
      <div className="w-100 flex flex-row justify-between items-center pa3 left-0 right-0 bh--inset bg-white bb b--black-05 sticky z-1 top-0">
        <div {...titleProps}>{title}</div>
        <div className="dib flex flex-row">
          {uuid && (
            <div className="pr2 mr2 br hairline-1">
              <ConfirmIconButton
                icon="delete"
                size={SMALL_ICON_SIZE}
                slides={getBlockRemovalSlides({ uid })}
                onConfirm={removeEntity({
                  values,
                  uuid,
                  setValues,
                  setFieldTouched
                })}
              />
            </div>
          )}
          <HoverIconButton {...buttonProps} />
        </div>
      </div>
    </Fragment>
  );
};

export default PanelHeader;
